import { Button } from "@/components/ui";
import { AssistantForm } from "@/screens/AssistantScreen";
import { useCompleteStep } from "./useCompleteStep";

export function StyleStep() {
  const complete = useCompleteStep();
  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="text-[24px] font-bold tracking-[-0.02em]">
          How should it behave?
        </h1>
        <p className="mt-1 text-[14px] text-muted">
          Helpful answers the question and stops. Conversion steers every
          exchange toward leaving contact details. Most companies sit somewhere
          in between.
        </p>
      </div>
      <AssistantForm />
      <div className="flex justify-end">
        <Button
          variant="primary"
          disabled={complete.isPending}
          onClick={() => complete.mutate("style")}
        >
          Continue
        </Button>
      </div>
    </div>
  );
}
